<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("cloudPrinterSetting.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("cloudPrinterSetting.Fields.backToList") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("cloudPrinterSetting.Fields.type") + $t("Global.colon") }}
                  <Required :show="savable" />
                </v-col>
                <v-col cols="9" md="7" v-if="isNew">
                  <v-radio-group row v-model="cloudPrint.type">
                    <v-radio
                      :label="$t('cloudPrinterSetting.type.default')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('cloudPrinterSetting.type.label')"
                      :key="1"
                      :value="1"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ cloudPrint.type == 0 ? $t("cloudPrinterSetting.type.default") : $t("cloudPrinterSetting.type.label") }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("cloudPrinterSetting.Fields.sn") + $t("Global.colon") }}
                  <Required :show="isNew" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="isNew">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('cloudPrinterSetting.Fields.sn')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="cloudPrint.sn"
                      :hint="$t('cloudPrinterSetting.Fields.sn_hint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'sn')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ cloudPrint.sn }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("cloudPrinterSetting.Fields.key") + $t("Global.colon") }}
                  <Required :show="isNew" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="isNew">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('cloudPrinterSetting.Fields.key')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="cloudPrint.printer_key"
                      :hint="$t('cloudPrinterSetting.Fields.key_hint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'printer_key')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ cloudPrint.printer_key }}
                </v-col>
              </v-row>
              <v-row align="center" v-if="cloudPrint.type == 0">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("cloudPrinterSetting.Fields.max_str") + $t("Global.colon") }}
                  <Required :show="isNew" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="isNew">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('cloudPrinterSetting.Fields.max_str')"
                    rules="required"
                  >
                    <v-select
                      style="padding-top: 0px"
                      v-model="cloudPrint.max_str"
                      :items="$consts.cloudPrinterMaxStr"
                      :error-messages="errors"
                      item-value="value"
                      item-text="text"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ cloudPrint.max_str | cloudPrinterMaxStrText }}
                </v-col>
              </v-row>
              <v-row align="center" v-if="cloudPrint.type == 1">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("cloudPrinterSetting.Fields.label_str") + $t("Global.colon") }}
                  <Required :show="isNew" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row>
                    <v-col cols="3" md="3">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('cloudPrinterSetting.Fields.label_str')"
                        :rules="{
                          required:true,
                          regex: '^[0-9]+$',
                        }"
                      >
                        <v-text-field
                          v-model="cloudPrint.label_width"
                          type="number"
                          style="max-width: 150px"
                          :error-messages="errors"
                          suffix="mm宽"
                        >
                          <template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                              {{ message }}
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-row align="center" class="ml-3" style="max-width: 20px;">
                      <span>X</span>
                    </v-row>
                    <v-col cols="3" md="3">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('cloudPrinterSetting.Fields.label_str')"
                        :rules="{
                          required:true,
                          regex: '^[0-9]+$',
                        }"
                      >
                        <v-text-field
                          v-model="cloudPrint.label_height"
                          type="number"
                          style="max-width: 150px"
                          :error-messages="errors"
                          suffix="mm高"
                        >
                          <template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                              {{ message }}
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ cloudPrint.label_width + "mm宽 X " + cloudPrint.label_height + "mm高"}}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("cloudPrinterSetting.Fields.remark") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field
                    v-model="cloudPrint.remark"
                    single-line
                    :hint="$t('cloudPrinterSetting.Fields.remark_hint')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ cloudPrint.remark }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("cloudPrinterSetting.Fields.carnum") + $t("Global.colon") }}
                  <Required :show="savable" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-text-field
                    v-model="cloudPrint.carnum"
                    single-line
                    :hint="$t('cloudPrinterSetting.Fields.carnum_hint')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ cloudPrint.carnum }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t('Stock.ObjectName') + $t("Global.colon") }}
                  <Required :show="savable" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <SearcherStocks
                    v-model="stocksSelected"
                    :stock_ids="cloudPrint.stock_ids"
                  />
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <v-chip
                    v-for="stock in show_stocks"
                    :key="stock.id"
                    small
                    label
                    outlined
                    color="info"
                    class="me-1"
                  >{{ stock.code }} / {{ stock.name }}
                  </v-chip>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("cloudPrinterSetting.Fields.backToList") }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView && $permission.permissionAllow('CloudPrints', 'edit')
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !cloudPrint.id"
                  @click="$emit('mode', 'edit')"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", [$t("cloudPrinterSetting.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow(
                    'CloudPrints',
                    isNew ? 'add' : 'edit'
                  )
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !cloudPrint.id"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("cloudPrinterSetting.ObjectName")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Required from "@/components/plugins/Required";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import CloudPrints from "@/api/cloud_prints";

export default {
  name: "CloudPrinterDetail",

  props: ["value", "mode", "stocks"],

  components: {
    Required,
    SearcherStocks,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    show_stocks() {
      if (this.cloudPrint.stock_ids) {
        let numArr = this.cloudPrint.stock_ids.split(","); // [x,x,x,x]
        let new1 = numArr.map((item) => {
          return { id: item };
        });
        // 过滤出 this.stocks 中id为 numArr 的数据
        let newArr = this.stocks.filter((item) => new1.some((v) => v.id == item.id));
        return newArr;
      }else {
        return []
      }
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    stocksSelected: [],
    cloudPrint: {},
    serverErrors: [],
  }),

  methods: {
    submit() {
      // this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            let cloudPrint = JSON.parse(JSON.stringify(this.cloudPrint));

            if (cloudPrint.id) {
              // 更新打印机
              CloudPrints.edit(cloudPrint).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", cloudPrint);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                    this.$refs.observer.reset();
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              ).catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
            }else {
              // 添加打印机
              CloudPrints.add(cloudPrint).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", cloudPrint);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                    this.$refs.observer.reset();
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              ).catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          this.cloudPrint = this.value;
        } else {
          // 添加云打印机，初始化默认值
          this.cloudPrint = {
            type: 0,
            sn: "",
            printer_key: "",
            carnum: "",
            remark: "",
            stock_ids: "",
            label_width: null,
            label_height: null,
          };
          this.stocksSelected = [];
        }
        this.$scrollTop(); //返回顶部
      },
    },
    stocksSelected: {
      handler() {
        let ids = [];
        this.stocksSelected.forEach((stock) => {
          ids.push(stock.id)
        });
        this.cloudPrint.stock_ids = this.stocksSelected ? ids.join(',') : "";
      }
    }
  },
};
</script>